import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import type { AppApi, PageToAdd } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

interface Params {
  pageType: PageToAdd
  editorSdkProxy: EditorSDK
  routerControllerRef: ComponentRef
  appApi: AppApi
}

export const openInspectorForPageType = async ({
  editorSdkProxy,
  appApi,
  pageType,
  routerControllerRef,
}: Params) => {
  if (pageType.key === 'itemPage') {
    const componentRef = await getTopTextComponent({
      editorSdkProxy,
      routerControllerRef,
    })

    return componentRef
      ? appApi.openInspectorBindingPanel({
          componentRef,
        })
      : appApi.openInspectorDatasetListPanel()
  } else if (pageType.key === 'indexPage') {
    const repeaters = await editorSdkProxy.components.findAllByRole({
      controllerRef: routerControllerRef,
      role: 'repeaterRole',
    })
    const repeaterRef = repeaters[0]
    return repeaterRef
      ? appApi.openInspectorBindingPanel({
          componentRef: repeaterRef,
        })
      : appApi.openInspectorDatasetListPanel()
  }
}

async function getTopTextComponent({
  editorSdkProxy,
  routerControllerRef,
}: {
  editorSdkProxy: EditorSDK
  routerControllerRef: ComponentRef
}) {
  const textComponents = await editorSdkProxy.components.findAllByRole({
    controllerRef: routerControllerRef,
    role: 'textRole',
  })
  if (!textComponents) {
    return null
  }
  const arrangedTextComponents = (
    await Promise.all(
      textComponents.map(async componentRef => {
        const index =
          await editorSdkProxy.document.components.arrangement.getIndex({
            componentRef,
          })
        return { componentRef, index }
      }),
    )
  ).sort((a, b) => a.index - b.index)
  return arrangedTextComponents[0]?.componentRef
}
